import { makeLazyComponent } from '../utils/lazy';

export const RegionSelector = makeLazyComponent(async () => ({
  default: (
    await import(/* webpackChunkName: "countryregionselector" */ 'react-country-region-selector')
  ).RegionDropdown,
}));
